// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mic-off';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 14.625v2.813m.42-5.086c-.405.045-3.795.233-3.795-3.915' />
    <path d='M11.348 14.13A5.85 5.85 0 0 1 9 14.625 5.52 5.52 0 0 1 3.375 9.24V7.312m11.25.001V9.24a5.25 5.25 0 0 1-1.56 3.712M2.25 1.688l13.5 14.062M5.625 5.205V3.938A3.367 3.367 0 0 1 9 .563a3.367 3.367 0 0 1 3.375 3.375v4.5a4.155 4.155 0 0 1-.892 2.864' />
  </g>
);

export const viewBox = '0 0 18 18';
